module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card card-quare p3333",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    ref: "preview",
    staticClass: "img-preview"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon iconfont font-lg font-light",
    class: [("icon-" + _vm.icon)]
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))])]), _vm._v(" "), _c('input', {
    ref: "file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.accept
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c8a79f5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/img-uploader/img-uploader.vue
// module id = 234
// module chunks = 17